export type SignageMediaType = 'image' | 'gif' | 'video';
export type SignageSource = 'url' | 'file';
// Kiosk screen state an item is shown in.
export type SignageState = 'waiting' | 'success' | 'failure';

export const SIGNAGE_STATES: { value: SignageState; label: string; hint: string }[] = [
  { value: 'waiting', label: 'Waiting for scan', hint: 'Shown while the kiosk waits for a scan.' },
  { value: 'success', label: 'Scan successful', hint: 'Shown after a successful scan.' },
  { value: 'failure', label: 'Scan unsuccessful', hint: 'Shown after an unsuccessful scan.' },
];


export interface ISignageStorePreview {
  itemId: string;
  mediaType: SignageMediaType;
  fileId?: string;
  sourceUrl?: string;
}

export type SignageOrientation = 'portrait' | 'landscape';

export const SIGNAGE_ORIENTATIONS: { value: SignageOrientation; label: string }[] = [
  { value: 'portrait', label: 'Portrait' },
  { value: 'landscape', label: 'Landscape' },
];

/** A store has one configuration for the device at its entrance and one for the device at its exit. */
export type SignageMode = 'entrance' | 'exit';

export const SIGNAGE_MODES: { value: SignageMode; label: string }[] = [
  { value: 'entrance', label: 'Entrance' },
  { value: 'exit', label: 'Exit' },
];

/** Device settings of one mode: whether videos play their sound and how the device is held. */
export interface ISignageModeSettings {
  playAudio: boolean;
  orientation: SignageOrientation;
}

/** What is sent when settings are saved; a mode that is left out stays as it is. */
export interface ISignageStoreSettings {
  entrance?: ISignageModeSettings;
  exit?: ISignageModeSettings;
}

export const MEDIA_SCALE_MIN = 1;
export const MEDIA_SCALE_DEFAULT = 100;

export interface ISignageStore extends ISignageStoreSettings {
  storeId: string;
  name: string;
  itemCount: number;
  visibleCount: number;
  previews: ISignageStorePreview[];
}

export interface ISignageItem {
  id: string;
  storeId: string;
  source: SignageSource;
  sourceUrl?: string;
  fileId?: string;
  fileName?: string;
  fileSizeBytes?: number;
  mediaType: SignageMediaType;
  mode: SignageMode;
  state: SignageState;
  eyebrow: string;
  title: string;
  subtitle: string;
  tag: string;
  sortOrder: number;
  durationSeconds?: number;
  loopCount: number;
  /** How large this media is shown: % of the height available in portrait, of the width in landscape (at least 1, no upper limit). */
  scalePercent?: number;
  enabled: boolean;
}

export interface ISignageItemRequest {
  storeId?: string;
  source: SignageSource;
  sourceUrl?: string;
  fileId?: string;
  mediaType?: SignageMediaType;
  mode?: SignageMode;
  state?: SignageState;
  eyebrow: string;
  title: string;
  subtitle: string;
  tag: string;
  durationSeconds?: number;
  loopCount?: number;
  scalePercent?: number;
  enabled: boolean;
}

export interface ISignageFile {
  id: string;
  filename: string;
  contentType: string;
  mediaType: SignageMediaType;
  sizeBytes: number;
  sha256: string;
}

export const DEFAULT_STORE_ID = '*';
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const ACCEPTED_UPLOAD_TYPES = 'image/jpeg,image/png,image/webp,image/gif,video/mp4,video/webm';
